export default {
  props: {
    position: {
      validator: (value) => {
        return ['left', 'right'].indexOf(value) !== -1;
      }
    }
  }
};